import React from 'react';
import ATSResumeTemplate from './ATSResumeTemplate';
function ATSCompact(props) { return <ATSResumeTemplate {...props} variant="compact" />; }
export default ATSCompact;